import FieldConfig from "../../../../proto/field-config"
import FieldDate from "../../../../generic/datetime/date/date"
import Task from "../../../../../model2/task/task"
import ItemModelV2 from "../../../../../model2/item2/item-model"
import FieldTaskEndDate_Popover from "./components/popover/popover"
import TasksViewManager from "../../../../../gd-modules/tasks-view/core/manager"
import {ViewType} from "../../../../../gd/const/views/view-type"
import GanttManager from "../../../../../gd-modules/gantt-chart/manager/manager"
import FieldProto_updateView from "../../../../proto/render/table/function/update-view"

export default class FieldTaskEndDate extends FieldDate {

    constructor(config:FieldConfig) {
        super(config);

        this.icon               = 'i5-date-end'
        this.label              = 'End date'

        this.minDate            = moment()


        this.fieldParams.highlightIfPastdue         = false
        this.fieldParams.tableCellOnValueChange     = this.tableCellOnValueChange

        this.components.PopoverMenu                 = FieldTaskEndDate_Popover
    }


    // ACCESS
    canEdit(model:Task):boolean {
        return model.acl.canChangeEndDate
    }

    // Custom Methods

    tableCellOnValueChange = (item: ItemModelV2, value:any, manager:TasksViewManager|GanttManager) => {
        switch (manager.module) {
            case ViewType.PROJECT_GANTT:
            case ViewType.PORTFOLIO_GANTT:
            case ViewType.CUSTOM_VIEW_GANTT:

                const newStartDate = item.task.startDate ? item.task.startDate : value
                const newEndDate = value

                const ganttManager = manager as GanttManager
                ganttManager.setStartEnd(item.id, newStartDate, newEndDate)

                break

            default:
                item.task.updateEndDate(value)
                item.task.save()

                item.updateLastUpdateTime() // otherwise it wont re-render

                FieldProto_updateView(manager as TasksViewManager, this)
                break
        }
    }

}
